/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EmployeeInterview,
  EmployeeInterviewResponse,
  EmployeesInterviewsListParams,
  NotFoundError,
  PatchedEmployeeInterviewRequestRequest,
  PaystubHeader,
  PaystubPeriodList,
  PermissionDeniedError,
  ServiceUnavailableError,
  SickTimeNoRegularRateError,
  SickTimeSummary,
  SickTimeUse,
  SickTimeUseError,
  SickTimeUseRequestRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getEmployeesInterviewsListUrl = (params?: EmployeesInterviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/employees/interviews/?${stringifiedParams}` : `/api/employees/interviews/`
}

export const employeesInterviewsList = async (params?: EmployeesInterviewsListParams, options?: Parameters<typeof customFetch>[1]): Promise<EmployeeInterviewResponse[]> => {

  return customFetch<EmployeeInterviewResponse[]>(getEmployeesInterviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEmployeesInterviewsListQueryKey = (params?: EmployeesInterviewsListParams,) => {
    return [
    `/api/employees/interviews/`, ...(params ? [params] : [])
    ] as const;
    }


export const getEmployeesInterviewsListQueryOptions = <TData = Awaited<ReturnType<typeof employeesInterviewsList>>, TError = void>(params?: EmployeesInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmployeesInterviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesInterviewsList>>> = ({ signal }) => employeesInterviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmployeesInterviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof employeesInterviewsList>>>
export type EmployeesInterviewsListQueryError = void


export function useEmployeesInterviewsList<TData = Awaited<ReturnType<typeof employeesInterviewsList>>, TError = void>(
 params: undefined |  EmployeesInterviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof employeesInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesInterviewsList<TData = Awaited<ReturnType<typeof employeesInterviewsList>>, TError = void>(
 params?: EmployeesInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof employeesInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesInterviewsList<TData = Awaited<ReturnType<typeof employeesInterviewsList>>, TError = void>(
 params?: EmployeesInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEmployeesInterviewsList<TData = Awaited<ReturnType<typeof employeesInterviewsList>>, TError = void>(
 params?: EmployeesInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesInterviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEmployeesInterviewsCreateUrl = () => {




  return `/api/employees/interviews/`
}

export const employeesInterviewsCreate = async ( options?: Parameters<typeof customFetch>[1]): Promise<EmployeeInterview> => {

  return customFetch<EmployeeInterview>(getEmployeesInterviewsCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEmployeesInterviewsCreateMutationKey = () => ['employeesInterviewsCreate'] as const;

export const getEmployeesInterviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesInterviewsCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesInterviewsCreate>>, TError,void, TContext> => {

const mutationKey = getEmployeesInterviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesInterviewsCreate>>, void> = () => {


          return  employeesInterviewsCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesInterviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof employeesInterviewsCreate>>>

    export type EmployeesInterviewsCreateMutationError = void


    export const useEmployeesInterviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesInterviewsCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof employeesInterviewsCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEmployeesInterviewsCreateMutationOptions(options), queryClient);
    }
    export const getEmployeesInterviewsRetrieveUrl = (id: string,) => {




  return `/api/employees/interviews/${id}/`
}

export const employeesInterviewsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<EmployeeInterviewResponse> => {

  return customFetch<EmployeeInterviewResponse>(getEmployeesInterviewsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEmployeesInterviewsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/employees/interviews/${id}/`
    ] as const;
    }


export const getEmployeesInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmployeesInterviewsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>> = ({ signal }) => employeesInterviewsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmployeesInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>>
export type EmployeesInterviewsRetrieveQueryError = void


export function useEmployeesInterviewsRetrieve<TData = Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesInterviewsRetrieve<TData = Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesInterviewsRetrieve<TData = Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEmployeesInterviewsRetrieve<TData = Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesInterviewsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEmployeesInterviewsPartialUpdateUrl = (id: string,) => {




  return `/api/employees/interviews/${id}/`
}

export const employeesInterviewsPartialUpdate = async (id: string,
    patchedEmployeeInterviewRequestRequest?: PatchedEmployeeInterviewRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<EmployeeInterviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<EmployeeInterviewResponse>(getEmployeesInterviewsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedEmployeeInterviewRequestRequest)
  }
);}





export const getEmployeesInterviewsPartialUpdateMutationKey = () => ['employeesInterviewsPartialUpdate'] as const;

export const getEmployeesInterviewsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesInterviewsPartialUpdate>>, TError,EmployeesInterviewsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesInterviewsPartialUpdate>>, TError,EmployeesInterviewsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getEmployeesInterviewsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesInterviewsPartialUpdate>>, EmployeesInterviewsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  employeesInterviewsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesInterviewsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof employeesInterviewsPartialUpdate>>>
    export type EmployeesInterviewsPartialUpdateMutationBody = PatchedEmployeeInterviewRequestRequest | undefined
    export type EmployeesInterviewsPartialUpdateMutationError = void
    export type EmployeesInterviewsPartialUpdateMutationVariables = {id: string;data?: PatchedEmployeeInterviewRequestRequest}

    export const useEmployeesInterviewsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesInterviewsPartialUpdate>>, TError,EmployeesInterviewsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof employeesInterviewsPartialUpdate>>,
        TError,
        EmployeesInterviewsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getEmployeesInterviewsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getEmployeesPaystubsRetrieveUrl = () => {




  return `/api/employees/paystubs/`
}

/**
 * GET /api/employees/paystubs/ — pay stub header for most recent or specific check.
 */
export const employeesPaystubsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<PaystubHeader> => {

  return customFetch<PaystubHeader>(getEmployeesPaystubsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEmployeesPaystubsRetrieveQueryKey = () => {
    return [
    `/api/employees/paystubs/`
    ] as const;
    }


export const getEmployeesPaystubsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmployeesPaystubsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>> = ({ signal }) => employeesPaystubsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmployeesPaystubsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>>
export type EmployeesPaystubsRetrieveQueryError = void


export function useEmployeesPaystubsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesPaystubsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesPaystubsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesPaystubsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesPaystubsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesPaystubsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesPaystubsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEmployeesPaystubsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesPaystubsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEmployeesPaystubsPeriodsRetrieveUrl = () => {




  return `/api/employees/paystubs/periods/`
}

/**
 * GET /api/employees/paystubs/periods/ — period picker list.
 */
export const employeesPaystubsPeriodsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<PaystubPeriodList> => {

  return customFetch<PaystubPeriodList>(getEmployeesPaystubsPeriodsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEmployeesPaystubsPeriodsRetrieveQueryKey = () => {
    return [
    `/api/employees/paystubs/periods/`
    ] as const;
    }


export const getEmployeesPaystubsPeriodsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmployeesPaystubsPeriodsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>> = ({ signal }) => employeesPaystubsPeriodsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmployeesPaystubsPeriodsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>>
export type EmployeesPaystubsPeriodsRetrieveQueryError = void


export function useEmployeesPaystubsPeriodsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesPaystubsPeriodsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesPaystubsPeriodsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEmployeesPaystubsPeriodsRetrieve<TData = Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesPaystubsPeriodsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesPaystubsPeriodsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEmployeesSickTimeRetrieveUrl = () => {




  return `/api/employees/sick-time/`
}

/**
 * GET /api/employees/sick-time/ — sick hours available to spend and the regular rate they pay at.
 */
export const employeesSickTimeRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<SickTimeSummary> => {

  return customFetch<SickTimeSummary>(getEmployeesSickTimeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEmployeesSickTimeRetrieveQueryKey = () => {
    return [
    `/api/employees/sick-time/`
    ] as const;
    }


export const getEmployeesSickTimeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError = SickTimeNoRegularRateError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmployeesSickTimeRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>> = ({ signal }) => employeesSickTimeRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmployeesSickTimeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>>
export type EmployeesSickTimeRetrieveQueryError = SickTimeNoRegularRateError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError


export function useEmployeesSickTimeRetrieve<TData = Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError = SickTimeNoRegularRateError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesSickTimeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesSickTimeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesSickTimeRetrieve<TData = Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError = SickTimeNoRegularRateError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof employeesSickTimeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof employeesSickTimeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmployeesSickTimeRetrieve<TData = Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError = SickTimeNoRegularRateError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useEmployeesSickTimeRetrieve<TData = Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError = SickTimeNoRegularRateError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesSickTimeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesSickTimeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEmployeesSickTimeUseCreateUrl = () => {




  return `/api/employees/sick-time/use/`
}

/**
 * POST /api/employees/sick-time/use/ — pay accrued sick hours at the regular rate on this period's check.
 *
 * 201 with the new payment; 200 with the original one when ``request_id`` was already used. Every 400 is
 * ``{"detail": "..."}``, the message the pro sees.
 */
export const employeesSickTimeUseCreate = async (sickTimeUseRequestRequest: SickTimeUseRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<SickTimeUse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SickTimeUse>(getEmployeesSickTimeUseCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sickTimeUseRequestRequest)
  }
);}





export const getEmployeesSickTimeUseCreateMutationKey = () => ['employeesSickTimeUseCreate'] as const;

export const getEmployeesSickTimeUseCreateMutationOptions = <TError = SickTimeUseError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesSickTimeUseCreate>>, TError,EmployeesSickTimeUseCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesSickTimeUseCreate>>, TError,EmployeesSickTimeUseCreateMutationVariables, TContext> => {

const mutationKey = getEmployeesSickTimeUseCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesSickTimeUseCreate>>, EmployeesSickTimeUseCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  employeesSickTimeUseCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesSickTimeUseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof employeesSickTimeUseCreate>>>
    export type EmployeesSickTimeUseCreateMutationBody = SickTimeUseRequestRequest
    export type EmployeesSickTimeUseCreateMutationError = SickTimeUseError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError
    export type EmployeesSickTimeUseCreateMutationVariables = {data: SickTimeUseRequestRequest}

    export const useEmployeesSickTimeUseCreate = <TError = SickTimeUseError | void | PermissionDeniedError | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesSickTimeUseCreate>>, TError,EmployeesSickTimeUseCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof employeesSickTimeUseCreate>>,
        TError,
        EmployeesSickTimeUseCreateMutationVariables,
        TContext
      > => {
      return useMutation(getEmployeesSickTimeUseCreateMutationOptions(options), queryClient);
    }
